import { render } from "./rectorStudioList.vue?vue&type=template&id=4fbd2284&scoped=true"
import script from "./rectorStudioList.vue?vue&type=script&lang=js"
export * from "./rectorStudioList.vue?vue&type=script&lang=js"

import "./rectorStudioList.vue?vue&type=style&index=0&id=4fbd2284&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbd2284"]])

export default __exports__